/* @xzz 2019-03-20 http://element-cn.eleme.io/#/zh-CN/component/message
参数            说明                                 可选值                  默认值
type            主题                         success/warning/info/error      info
info            消息文字                             -                       -   
showClose       是否显示关闭按钮                     boolean                  true 
duration        显示时间毫秒/设为0则不会自动关闭        number                 3000
*/
import Vue from 'vue';
import ElementUI from 'element-ui'; // 确保引入 Element（避免依赖缺失）

/*
// 确保 ElementUI 已初始化（如果 main.js 没执行，这里补执行）
// 因采用插件形式，所以这里无需初始化 ElementUI
if (!Vue.prototype.$ELEMENT) { // $ELEMENT 是 Element 初始化后挂载的全局配置
  Vue.use(ElementUI, { size: "small" });
}
*/

//// 不需要再 new Vue()，直接用 Element 的静态方法更稳定
//let vue =new Vue();

// 添加全局消息实例变量，用于存储当前显示的消息
let currentMessageInstance = null;

//消息提示 常用于主动操作后的反馈提示, 支持 this.$message("","error")等直接调用方式
function Message(options,type) {

    //console.log("进入Message1", options, type);

    // 处理两个参数的情况 (message, type)
    if (typeof options === 'string') {
        options = {
            message: options,
            type: type || 'success',
            showClose: true,
            duration:  3000,
            center: false
        };
    }
    // 处理对象参数情况
    else if (typeof options === 'object') {
        options = {
            message: options.message,
            type: options.type || 'success',
            showClose: options.showClose !== undefined ? options.showClose : true,
            duration: options.duration || 3000,
            center: options.center || false
        };
    }
    
    // 如果有正在显示的消息实例，先关闭它
    if (currentMessageInstance) {
        // 直接更新弹窗的核心属性（内容、类型）
        currentMessageInstance.message = options.message;
        currentMessageInstance.type = options.type;
        // 重置倒计时（可选：让更新后的弹窗重新计时关闭，避免刚更新就消失）
        if (currentMessageInstance.timer) {
            clearTimeout(currentMessageInstance.timer);
            currentMessageInstance.timer = setTimeout(() => {
                currentMessageInstance.close();
            }, options.duration);
        }
    }else{
       // 此时 ElementUI 已被 Vue.use() 初始化，才可正常使用
       // 直接用 ElementUI.Message 构造实例（更稳定，不依赖 vue.$message）
      currentMessageInstance = ElementUI.Message({
          message: options.message,
          type: options.type,
          showClose: options.showClose,
          duration: options.duration,
          center: options.center,
          onClose: () => {
              // 消息关闭时清空实例引用
              currentMessageInstance = null;
              // 如果有原始的onClose回调，也调用它
              if (options.onClose && typeof options.onClose === 'function') {
                options.onClose();
              }
          }
      });
    }


    
    return currentMessageInstance;
}

// 添加各种类型的方法，支持 this.$message.error("") 等调用方式
['success', 'warning', 'info', 'error'].forEach(type => {
    Message[type] = function(options) {
        //console.log(`vue 调用 ${type} 方法，参数：`, options); 
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        options.type = type;
        return Message(options);
    };
});


//MessageBox的作用是美化系统自带的 alert、confirm 和 prompt
function MessageBoxAlert(info,title,confirmButtonText){
    vue.$alert(info,title||'提示', {
        confirmButtonText: confirmButtonText||'确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${ action }`
          });
        }
      });
}

//提示用户确认其已经触发的动作，并询问是否进行此操作时会用到此对话框。
function MessageBoxConfirm(info,callback,calCallback,title,confirmButtonText,cancelButtonText){
    vue.$confirm(info, title||'提示', {
        confirmButtonText: confirmButtonText||'确定',
        cancelButtonText: cancelButtonText||'取消',
        type: 'warning'
      }).then(() => {
        callback();
      }).catch(() => {
        calCallback&&calCallback();        
      });
}
function MessageBoxPrompt(info){
    
}


/*
Vue.prototype.$message = window.$message = Message;
Vue.prototype.$MessageBoxConfirm = window.$MessageBoxConfirm = MessageBoxConfirm;
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox;
// Vue.prototype.$confirm  = EleMessageBox;
// Vue.prototype.$prompt = EleMessageBox;
*/

// 关键：将 notice 封装为 Vue 插件，通过 install 方法挂载
const NoticeMessagePlugin = {
  install(Vue) {
    // 插件安装时（Vue.use(NoticePlugin)）才挂载 $message，确保 Element 已初始化
    Vue.prototype.$message = window.$message = Message;
    Vue.prototype.$MessageBoxConfirm = window.$MessageBoxConfirm = MessageBoxConfirm;
    console.log('NoticeMessagePlugin 安装成功，$message 已挂载');
  }
};

// 导出插件（而非直接挂载）
export default NoticeMessagePlugin;